import compileEnhancedMarkdown from '../../resources/js/components/EnhancedMarkdown/helpers/compileEnhancedMarkdown';
import enhancedMarkdownOverrides from './enhancedMarkdownOverrides';
import flattenChildren from './flattenChildren';

function extractComponentsFromEnhancedMarkdown(markdown, context) {
  const output = compileEnhancedMarkdown(
    markdown,
    enhancedMarkdownOverrides,
    context
  );

  return flattenChildren(output.props.children, context.pageViewModels?.game);
}

export default extractComponentsFromEnhancedMarkdown;
